var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDotright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297.613 297.613",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 15.279,
    cy: 103.81,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.32,
    cy: 103.81,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.261,
    cy: 103.81,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 59.77,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 103.81,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 14.83,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.343,
    cy: 59.77,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.343,
    cy: 103.81,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.279,
    cy: 147.852,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.32,
    cy: 147.852,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.261,
    cy: 147.852,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 147.852,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.343,
    cy: 147.852,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.279,
    cy: 192.791,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.32,
    cy: 192.791,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.261,
    cy: 192.791,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 192.791,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.343,
    cy: 192.791,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 236.887,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.343,
    cy: 236.887,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.238,
    cy: 103.81,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.238,
    cy: 147.852,
    r: 14.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.238,
    cy: 192.791,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.302,
    cy: 282.782,
    r: 14.831
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.334,
    cy: 147.852,
    r: 14.83
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDotright);
export default __webpack_public_path__ + "static/media/ImageDotright.2da371aca5328e4dd4f18feb030068ac.svg";
export { ForwardRef as ReactComponent };